export default __webpack_public_path__ + "static/media/portada_CeciliaRamos.a54975fd.jpg";